import {useMemo} from 'react';

export const useGroupByYear = (values) => {
    const groupedData = useMemo(()=> {
        return values.reduce((acc, value) => {
            const date = new Date(value?.created_at || value?.product_data.start_date);
            const year = date.getFullYear();

            if (!acc[year]) acc[year] = [];
            acc[year].push(value);

            return acc;
        }, {})
    }, [values]);

    const hasData = Object.keys(groupedData).length > 0;

    return {
        groupedData,
        hasData
    };
};